<template>
    <div class="main">
        <div class="title">
            <div class="title1" @click="addPost">
                <div>+&nbsp;&nbsp;发布职位</div>
            </div>
            <div class="title2">
                <div class="search">
                    <el-input placeholder="搜索职位名称,点击回车搜索" suffix-icon="el-icon-search" v-model="keyWords"
                              @keyup.enter.native="getCompanyPositionList" />
                </div>
                <el-cascader v-model="positionType" :options="positionTypeList"
                             :props="{ value: 'positionTypeId', label: 'typeName' }" @change="handleChange" placeholder="请选择职位类型">
                </el-cascader>
                <el-button @click="reset" style="margin-left: 10px;">重置</el-button>
            </div>
        </div>
        <div class="filter">
            <div :class="{ active: active == index, common: active != index }" v-for="(item, index) in chooseTypes"
                 :key="index" @click="switchStatus(item, index)">
                {{ item.text }}
            </div>
        </div>
        <div class="postManagement">

            <el-table :data="positionList" class="table" @sort-change="sortChange">
                <el-table-column label="岗位名称" align="center" width="170" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis">{{ scope.row.positionTitle }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="岗位信息" align="center" width="170" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis">
                            <span>{{ scope.row.cityName }}</span>| <span v-if="scope.row.salaryUnit == '面议'">{{
                scope.row.salaryUnit
              }}</span><span v-else>{{ scope.row.salaryBegin }}-{{ scope.row.salaryEnd }}{{
                  scope.row.salaryUnit
                }}</span> |
                            <span>{{ scope.row.workCycle == 0 ? '兼职' : '全职' }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="communityTypeName" label="社区信息" width="70" align="center" />
                <el-table-column prop="viewCount" label="浏览量" width="70" align="center" />
                <el-table-column prop="chatCount" label="沟通数" width="70" align="center" />
                <el-table-column prop="collectCount" label="收藏数" width="70" align="center" />
                <el-table-column label="状态" align="center" width="70">
                    <template slot-scope="scope">
                        {{ scope.row.examineStatus == 0 ? '待审核' : scope.row.examineStatus == 1 ? scope.row.status == 0 ? '待开放' :
                        scope.row.status == 1 ? '开放中' : scope.row.status == 2 ? '暂停中' : scope.row.status == 3 ? '已关闭' : '' :
                        scope.row.examineStatus ==
                        2 ? '审核驳回' : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="170" sortable />
                <el-table-column label="操作" align="center" width="170">
                    <template slot-scope="scope">
                        <div class="item4">
                            <div @click="getQrcode(scope.row.positionId)">二维码</div>
                            <div @click="edit(scope.row.positionId, 1)" v-if="scope.row.examineStatus != 2">编辑</div>
                            <div @click="edit(scope.row.positionId, 2)" v-if="scope.row.examineStatus == 2">重发</div>
                            <div @click="edit(scope.row.positionId, 3)" v-if="scope.row.examineStatus != 2">查看</div>
                            <div v-if="scope.row.status == 2" @click="editStatus(scope.row.positionId, '1')">开放</div>
                            <div v-if="scope.row.status == 1" @click="editStatus(scope.row.positionId, '2')">暂停</div>
                            <div v-if="scope.row.status != 3 && scope.row.examineStatus == 1"
                                 @click="editStatus(scope.row.positionId, '3')">关闭</div>
                            <div @click="delPosition(scope.row.positionId)">删除</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer">
            <div>共{{ total }}个职位</div>
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
                           layout="prev, pager, next, jumper" :page-size="10" :total="total">
            </el-pagination>
        </div>
        <el-dialog
                :title="addOrEdit == 'add' || addOrEdit == 'again' ? '发布职位' : addOrEdit == 'check' ? '查看职位' : addOrEdit == 'edit' ? '编辑职位' : ''"
                inline :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="closeDialog">
            <el-form :model="form" class="form" ref="form" label-width="90px" :rules="addOrEdit != 'check'?rules:''" :disabled="addOrEdit == 'check'">
                <el-form-item label="职位标题" prop="positionTitle">
                    <el-input v-model="form.positionTitle" placeholder="请输入职位标题"></el-input>
                </el-form-item>

              <el-form-item label="是否急聘" prop="isUrgent">
                <el-radio-group v-model="form.isUrgent">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
                <el-form-item label="职位类型" prop="positionType">
                    <el-cascader v-model="form.positionType" :options="positionTypeList" filterable
                                 :props="{ value: 'positionTypeId', label: 'typeName' }" style="width: 100%;"
                                 placeholder="请选择职位类型"></el-cascader>
                </el-form-item>
                <el-form-item label="职位偏好" prop="positionWorkTypeId">
                    <el-select v-show="addOrEdit != 'check'" v-model="form.positionWorkTypeId" placeholder="请选择职位偏好" multiple style="width: 100%">
                        <el-option :label="item.typeName" :value="item.workTypeId" v-for="(item, index) in workTypeList"
                                   :key="index"></el-option>
                    </el-select>
                    <div v-show="addOrEdit == 'check'">
                        <el-input v-model="form.positionTag" placeholder="请选择职位偏好"></el-input>
                    </div>
                </el-form-item>
<!--                <el-form-item label="社区信息" prop="communityTypeName">
                    <el-select v-show="addOrEdit != 'check'" v-model="form.communityTypeName" placeholder="请选择社区信息"  style="width: 100%">
                        <el-option :label="item.communityTypeName" :value="item.communityTypeName" v-for="(item, index) in communityTypeList"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item label="职位标签" prop="positionTag">
                    <el-select v-model="form.positionTag" placeholder="请选择职位标签" multiple style="width: 100%">
                        <el-option :label="item.tagName" :value="item.tagName" v-for="(item, index) in tagList"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算方式" prop="settlementMethod">
                    <el-select v-model="form.settlementMethod" placeholder="请选择结算方式" style="width: 100%">
                        <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in settlement_method"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择职位展示平台" prop="plantFlag" v-if="companyUserId === '0f79248375ff42c6a54926a57e8c61c2'">
                    <el-select v-model="form.plantFlag" placeholder="请选择平台" style="width: 100%">
                        <el-option
                                v-for="item in flagOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用工时间">
                    <el-col :span="4">
                        <el-form-item prop="workCycle">
                            <el-select v-model="form.workCycle" placeholder="用工类型">
                                <el-option label="短期" :value="0"></el-option>
                                <el-option label="长期" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="1">
                        <el-form-item prop="weekWorkDay">
                            <el-select v-model="form.weekWorkDay" placeholder="每周工作时间">
                                <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in week_work_day"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" :offset="1">
                        <el-form-item prop="workTime">
                            <el-select v-model="form.workTime" placeholder="工作时间">
                                <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in work_time"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" :offset="1">
                        <el-form-item prop="workPeriod">
                            <el-select v-model="form.workPeriod" placeholder="工作时段" multiple collapse-tags @change="workPeriodChange">
                                <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in work_period"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="薪资范围">
                    <el-col :span="9">
                        <el-form-item prop="salaryBegin">
                            <el-input type="number" :min="1" step="50" :disabled="form.salaryUnit == '面议'" v-model="form.salaryBegin"
                                      placeholder="最低薪资" @blur="salaryBlur(1, $event)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" :offset="1">
                        <el-form-item prop="salaryEnd">
                            <el-input type="number" :min="1" step="50" :disabled="form.salaryUnit == '面议'" v-model="form.salaryEnd"
                                      placeholder="最高薪资" @blur="salaryBlur(2, $event)" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" :offset="1">
                        <el-form-item prop="salaryUnit">
                            <el-select @change="salaryUnit" v-model="form.salaryUnit" placeholder="薪资单位">
                                <el-option :label="item.paramName" :value="item.paramName" v-for="(item, index) in salary_range"
                                           :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="联系方式(手机号)" prop="contactPhone">
                    <el-input v-model="form.contactPhone" placeholder="请输入联系方式(手机号)"></el-input>
                </el-form-item>
                <el-form-item label="联系方式(固话)" prop="telephone">
                    <el-input v-model="form.telephone" placeholder="请输入联系方式(固话)"></el-input>
                </el-form-item>
                <el-form-item label="招聘人数" prop="recruitNumber">
                    <el-input type="number" min="0" step="1" v-model="form.recruitNumber" placeholder="请输入招聘人数"></el-input>
                </el-form-item>
                <el-form-item label="工作地点" prop="region">
                    <el-cascader v-model="form.region" :options="regionTreeList" :props="{ value: 'label' }"
                                 @change="changeRegion" style="width: 100%" placeholder="请选择工作地点" />
                </el-form-item>
                <el-form-item label="详细地址" prop="workAddress">
                    <el-input v-model="form.workAddress" placeholder="请选择详细地址" @focus="setAddress"></el-input>
                </el-form-item>
                <el-form-item label="职位描述" prop="positionDescribe">
                    <rich-text v-model="form.positionDescribe" v-if="addOrEdit != 'check'" :placeholder="'请输入职位描述'" />
                    <div style="word-break: break-all; white-space: pre-line;" v-html="form.positionDescribe"
                         v-if="addOrEdit == 'check'"></div>
                </el-form-item>
                <el-form-item label="人员要求" prop="personnelRequire">
                    <rich-text v-model="form.personnelRequire" v-if="addOrEdit != 'check'" :placeholder="'请输入人员要求'" />
                    <div style="word-break: break-all; white-space: pre-line;" v-html="form.personnelRequire"
                         v-if="addOrEdit == 'check'"></div>
                </el-form-item>
                <el-form-item label="福利提成" prop="welfareCommission">
                    <rich-text v-model="form.welfareCommission" v-if="addOrEdit != 'check'" :placeholder="'请输入福利提成'" />
                    <div style="word-break: break-all; white-space: pre-line;" v-html="form.welfareCommission"
                         v-if="addOrEdit == 'check'"></div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit" :disabled="addOrEdit == 'check'">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="show" class="mapDialog">
            <iframe id="mapPage" width="100%" height="500px" frameborder=0
                    :src="`https://apis.map.qq.com/tools/locpicker?coord=${coord}?search=1&type=1&key=RGEBZ-ARFKN-7NRF5-SNH73-OUVK3-KEBE7&referer=刘湾零工市场'`"">
            </iframe>
        </el-dialog>
        <el-dialog :visible.sync="show1">
            <el-form :model="form1" class="form1" ref="form1" :rules="rules1" label-width="100px">
                <el-form-item label="真实姓名" prop="realName">
                    <el-input v-model="form1.realName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idNumber">
                    <el-input v-model="form1.idNumber" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面" prop="idCardFront">
                    <image-upload v-model="form1.idCardFront" :limit="1"></image-upload>
                </el-form-item>
                <el-form-item label="身份证反面" prop="idCardBack">
                    <image-upload v-model="form1.idCardBack" :limit="1"></image-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit1">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="show2">

            <el-form :model="form2" class="form2" ref="form2" :rules="rules2" label-width="100px">
                <el-form-item label="公司LOGO" prop="companyImage">
                    <image-upload v-model="form2.companyImage" :limit="1"></image-upload>
                </el-form-item>
                <el-form-item label="营业执照" prop="businessLicense">
                    <image-upload v-model="form2.businessLicense" :limit="1" @input="handleUploadSuccess"></image-upload>
                </el-form-item>

                <el-form-item label="公司全称" prop="companyName">
                    <el-input v-model="form2.companyName" placeholder="请输入公司全称" />
                </el-form-item>
                <el-form-item label="公司规模" prop="companySize">
                    <el-input v-model="form2.companySize" placeholder="请输入公司规模" />
                </el-form-item>
                <el-form-item label="工作地点" prop="region">
                    <el-cascader v-model="form2.region" :options="regionTreeList" :props="{ value: 'label' }" style="width: 100%"
                                 @change="changeRegion2" placeholder="请选择工作地点" />
                </el-form-item>
                <el-form-item label="详细地址" prop="companyAddress">
                    <el-input v-model="form2.companyAddress" placeholder="请选择详细地址" @focus="setAddress" />
                </el-form-item>
                <el-form-item label="企业介绍" prop="companyIntroduce">
                    <el-input type="textarea" v-model="form2.companyIntroduce" placeholder="请输入企业介绍" />
                </el-form-item>
                <el-form-item label="经营范围" prop="businessScope">
                    <el-input type="textarea" v-model="form2.businessScope" placeholder="请输入企业经营范围" />
                </el-form-item>
                <el-form-item label="成立时间" prop="establishTime">
                    <el-date-picker v-model="form2.establishTime" type="date" placeholder="请选择成立时间" value-format="yyyy-MM-dd"
                                    style="width: 100%;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="注册资本" prop="registeredCapital">
                    <el-input type="number" v-model="form2.registeredCapital" :min="1" placeholder="请输入注册资本，单位为万">
                        <template slot="append">万</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="法人代表" prop="legalRepresentative">
                    <el-input v-model="form2.legalRepresentative" placeholder="请输入法人代表" />
                </el-form-item>
                <el-form-item label="职务">
                    <el-input v-model="form2.companyUserPosition" placeholder="请输入您的职务" />
                </el-form-item>


                <el-form-item label="同意知情书" props="checked">
                    <el-checkbox v-model="form2.checked" />
                    <span style="padding-left: 10px;" @click="showText = true">知情协议书</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit2">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showShare" class="qrcodeDialog" width="500px">
            <div class="sha_image" @click="closeShare">
                <!-- <canvas type="2d" :class="('id' + qrcodePositionId)" /> -->
                <img :src="qrcode" alt="">
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showText" class="qrcodeDialog" width="500px">
            <div v-html="company_informed_agreement ? company_informed_agreement.ruleContent : ''">
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import richText from '../../components/richText.vue';
    import axios from 'axios';

    export default {
        components: { richText },
        data() {
            return {
                chooseTypes: [{
                    text: '职位列表'
                }, {
                    text: '待审核',
                    examineStatus: "0"
                }, {
                    text: '审核通过',
                    examineStatus: "1"
                }, {
                    text: '审核驳回',
                    examineStatus: "2"
                }, {
                    text: '开放中',
                    status: '1'
                }, {
                    text: '暂停中',
                    status: '2'
                }, {
                    text: '已关闭',
                    status: '3'
                }],
                flagOptions: [
                    {
                        value: '0',
                        label: '龙都学子平台'
                    },
                    {
                        value: '1',
                        label: '全平台'
                    },],
                pageNum: 1,
                active: 0,
                total: 10,
                keyWords: "",
                positionTypeIdSecondary: "",
                examineStatus: '',
                status: '',
                dialogFormVisible: false,
                show1: false,
                show2: false,
                showText: false,
                positionType: [],
              isUrgent: 0, // 默认值设为0（否）
                communityTypeList:[],
                form: {
                    telephone:null,
                    plantFlag: '0',
                    positionTypeId: null,
                    positionTypeIdSecondary: null,
                    positionType: [],
                    positionTitle: null,
                    positionWorkTypeId: '',
                    workCycle: null,
                    weekWorkDay: null,
                    workTime: '',
                    workPeriod: [],
                    provinceName: null,
                    cityName: null,
                    areaName: null,
                    workAddress: null,
                    longitude: null,
                    latitude: null,
                    salaryBegin: null,
                    salaryEnd: null,
                    salaryUnit: null,
                    contactPhone: null,
                    positionDescribe: '',
                    recruitNumber: null,
                    flag: null,
                    settlementMethod: '',
                    plantFlag: '0',
                    communityTypeName:'',
                    personnelRequire: '',
                    welfareCommission: '',
                    positionTag: [],
                    region: [],
                },
                rules: {
                    positionTitle: [
                        { required: true, message: '请输入职位标题', trigger: 'blur' },
                    ],
                    positionType: [
                        { required: true, message: '请选择职位类型', trigger: 'change' },
                    ],
                    positionWorkTypeId: [
                        { required: true, message: '请选择职位偏好', trigger: 'change' },
                    ],
                    communityTypeName: [
                        { required: true, message: '请输入社区信息', trigger: 'change' },
                    ],
                  isUrgent: [
                  /*  { required: true, message: '请选择是否急聘', trigger: 'change' }*/
                  ],
                    positionTag: [
                        { required: true, message: '请选择职位标签', trigger: 'change' },
                    ],
                    settlementMethod: [
                        { required: true, message: '请选择结算方式', trigger: 'change' },
                    ],
                    flag: [
                        { required: true, message: '请选择展示平台', trigger: 'change' },
                    ],
                    workCycle: [
                        { required: true, message: '请选择用工类型', trigger: 'change' },
                    ],
                    weekWorkDay: [
                        { required: true, message: '请选择每周工作时间', trigger: 'change' },
                    ],
                    workTime: [
                        { required: true, message: '请选择工作时间', trigger: 'change' },
                    ],
                    workPeriod: [
                        { required: true, message: '请选择工作时段', trigger: 'change' },
                    ],
                    salaryBegin: [
                        { required: true, message: '请输入最低薪资', trigger: 'blur' },
                    ],
                    salaryEnd: [
                        { required: true, message: '请输入最高薪资', trigger: 'blur' },
                    ],
                    salaryUnit: [
                        { required: true, message: '请选择薪资单位', trigger: 'change' },
                    ],
                    contactPhone: [
                        { required: false, message: '请输入联系方式(手机号)', trigger: 'blur' },
                        { max: 11, message: "手机号长度为11位", trigger: "blur" },
                        { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
                    ],
                    telephone: [
                        { required: false, message: '请输入电话号码', trigger: 'blur' }, // 假设你希望在失去焦点时触发验证
                        { type: 'string', pattern: /^\d+$/, message: '电话号码只能包含数字', trigger: 'change' } // 使用正则表达式限制输入
                    ],
                    positionDescribe: [
                        { required: true, message: '请输入职位描述', trigger: 'blur' },
                    ],
                    recruitNumber: [
                        { required: true, message: '请输入招聘人数', trigger: 'blur' },
                    ],
                    region: [
                        { required: true, message: '请选择工作地点', trigger: 'change' },
                    ],
                    workAddress: [
                        { required: true, message: '请选择详细地址', trigger: 'change' },
                    ],
                },
                form1: {
                    realName: '',
                    idNumber: '',
                    idCardFront: '',
                    idCardBack: ''
                },
                rules1: {
                    realName: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' },
                    ],
                    idNumber: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' },
                        { pattern: /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[\d|X|x]$/, message: '请输入正确的身份证号', trigger: 'blur' },
                    ],
                    idCardFront: [
                        { required: true, message: '请选择身份证正面', trigger: 'on-change' }
                    ],
                    idCardBack: [
                        { required: true, message: '请选择身份证反面', trigger: 'on-change' }
                    ],
                },
                form2: {
                    companyImage: '',
                    companyName: '',
                    companyUserPosition: '',
                    companyIntroduce: '',
                    businessLicense: '',
                    companySize: '',
                    businessScope: '',
                    establishTime: '',
                    registeredCapital: '',
                    legalRepresentative: '',
                    provinceName: '',
                    cityName: '',
                    areaName: '',
                    companyAddress: '',
                    companyLongitude: '',
                    companyLatitude: '',
                    region: [],
                    checked: false,
                },
                rules2: {
                    companyName: [
                        { required: true, message: '请输入公司名称', trigger: 'blur' },
                    ],

                    companySize: [
                        { required: true, message: '请输入公司规模', trigger: 'blur' },
                    ],
                    region: [
                        { required: true, message: '请选择工作地点', trigger: 'change' },
                    ],
                    companyAddress: [
                        { required: true, message: '请选择详细地址', trigger: 'change' },
                    ],
                    companyIntroduce: [
                        { required: true, message: '请输入企业介绍', trigger: 'blur' },
                    ],
                    businessScope: [
                        { required: true, message: '请输入企业经营范围', trigger: 'blur' },
                    ],
                    establishTime: [
                        { required: true, message: '请选择成立时间', trigger: 'change' },
                    ],
                    registeredCapital: [
                        { required: true, message: '请输入注册资本', trigger: 'blur' },
                    ],
                    legalRepresentative: [
                        { required: true, message: '请输入法人代表', trigger: 'blur' },
                    ],
                    companyUserPosition: [
                        { required: true, message: '请输入您的职务', trigger: 'blur' },
                    ],
                    companyImage: [
                        { required: true, message: '请上传公司LOGO', trigger: 'on-change' },
                    ],
                    businessLicense: [
                        { required: true, message: '请上传公司营业执照', trigger: 'on-change' },
                    ],
                    checked: [
                        { required: true, message: '请同意知情书', trigger: 'change' },
                    ],
                },
                positionList: [],
                showShare: false,
                positionTypeList: [],
                regionTreeList: [],
                chooseId: '',
                settlement_method: [],
                week_work_day: [],
                companyUserId: null,
                communityTypeList: [],
                work_time: [],
                work_period: [],
                salary_range: [],
                tagList: [],
                submitType: 0,
                show: false,
                authType: '',
                qrcodePositionId: '',
                qrcode: '',
                qrCodeGet: false,
                workTypeList: [],
                addOrEdit: '',
                authObj: {},
                orderType: '1',
                company_informed_agreement: null,
                coord: '',
            };
        },

        mounted() {
            this.getCompanyUserIdMethod()
            this.getCompanyPositionList()
            this.init()

            this.getPositionListByPid1()

            let that = this
            window.addEventListener('message', function (event) {
                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                var loc = event.data;
                if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    // console.log('location', loc);
                    if (that.dialogFormVisible) {
                        that.form.longitude = loc.latlng.lng
                        that.form.latitude = loc.latlng.lat
                        // that.form.workAddress = loc.poiaddress
                        that.form.workAddress = loc.poiname
                        that.$forceUpdate()
                    } else if (that.show2) {
                        that.form2.companyLongitude = loc.latlng.lng
                        that.form2.companyLatitude = loc.latlng.lat
                        // that.form2.companyAddress = loc.poiaddress
                        that.form2.companyAddress = loc.poiname
                    }
                    that.show = false
                }
            }, false);
        },
        methods: {
            salaryUnit(e) {
                console.log(e);
                if (e == '面议') {
                    this.rules.salaryBegin[0].required = false
                    this.rules.salaryEnd[0].required = false
                } else {
                    this.rules.salaryBegin[0].required = true
                    this.rules.salaryEnd[0].required = true
                }
            },

            handleUploadSuccess(e) {
                // console.log(e,'123');
                if (e) {
                    this.$get('/api/company/company/getOCRResult', { url: e }).then(res => {
                        console.log(res);
                        this.form2.legalRepresentative = res.data.legalRepresentative
                        this.form2.companyName = res.data.companyName
                        this.form2.businessScope = res.data.businessScope
                        this.form2.establishTime = res.data.establishTime
                    })
                }
            },

            sortChange({ column, prop, order }) {
                // console.log(column, prop, order )
                this.orderType = order == 'ascending' ? '0' : '1'
                this.getCompanyPositionList()
            },
            resetForm() {
                this.form = {
                  isUrgent: 0, // 添加或确保存在这个字段
                    positionTypeId: null,
                    positionTypeIdSecondary: null,
                    positionType: [],
                    positionTitle: null,
                    positionWorkTypeId: '',
                    workCycle: null,
                    weekWorkDay: null,
                    workTime: '',
                    workPeriod: [],
                    provinceName: null,
                    cityName: null,
                    areaName: null,
                    workAddress: null,
                    longitude: null,
                    latitude: null,
                    salaryBegin: null,
                    salaryEnd: null,
                    salaryUnit: null,
                    contactPhone: null,
                    positionDescribe: '',
                    recruitNumber: null,
                    flag: null,
                    settlementMethod: '',
                    personnelRequire: '',
                    welfareCommission: '',
                    positionTag: [],
                    region: [],
                }
            },
            getCompanyUserAuthStatus() {
                this.coord = ''
                this.$get('/api/company/companyUser/getCompanyUserAuthStatus', {}).then(res => {
                    console.log(res,'res');
                    this.authObj = res.data
                    this.authType = res.data.authType;
                    if (this.authType == '0') {
                        if (this.authObj.personExamineStatus == '0') {
                            this.show1 = true
                        } else if (this.authObj.personExamineStatus == '1') {
                            this.$message({
                                message: '实名信息正在审核中，请耐心等待',
                                type: 'warning'
                            })
                        } else if (this.authObj.personExamineStatus == '3') {
                            this.$message({
                                message: this.authObj.personExamineRefuseReason,
                                type: 'warning'
                            })
                            this.show1 = true
                        }
                    } else if (this.authType == '1') {
                        if (this.authObj.companyExamineStatus == null) {
                            this.show2 = true
                        } else if (this.authObj.companyExamineStatus == '0') {
                            this.$message({
                                message: '提交信息正在审核中，请耐心等待',
                                type: 'warning'
                            })
                        } else if (this.authObj.companyExamineStatus == '2') {
                            this.$message({
                                message: this.authObj.companyExamineRefuseReason,
                                type: 'warning'
                            })
                            this.show2 = true
                        }
                    }
                })
            },
            salaryBlur(type, value) {
                if (type == 1) {
                    if (this.form.salaryBegin < 1) {
                        this.form.salaryBegin = 1
                    }
                    if (this.form.salaryEnd) {
                        if (this.form.salaryBegin <= parseFloat(this.form.salaryEnd)) {
                        } else {
                            this.form.salaryBegin = this.form.salaryEnd
                            this.$message({
                                message: '期望最低薪资需小于期望最高薪资',
                                type: 'error'
                            })
                        }
                    }
                } else if (type == 2) {
                    if (this.form.salaryEnd < 1) {
                        this.form.salaryEnd = 1
                    }
                    if (this.form.salaryBegin) {
                        if (this.form.salaryEnd >= parseFloat(this.form.salaryBegin)) {
                        } else {
                            this.form.salaryEnd = this.form.salaryBegin
                            this.$message({
                                message: '期望最高薪资需大于期望最低薪资',
                                type: 'error'
                            })
                        }
                    }
                }
            },
            init() {
                this.getCompanyUserAuthStatus()
            },
            reset() {
                this.keyWords = ''
                this.positionType = []
                this.positionTypeIdSecondary = ''
                this.getCompanyPositionList()
            },
            getPositionWorkTypeList() {
                this.$get('/api/company/position/getPositionWorkTypeList', {}).then(res => {
                    this.workTypeList = res.data
                })
            },
            submit1() {
                let that = this
                that.$refs.form1.validate(valid => {
                    if (valid) {
                        that.$post('/api/company/companyUser/companyAuthPerson', { ...that.form1 }).then(res => {
                            that.$message({
                                message: '实名信息提交成功，请耐心等待审核',
                                type: 'success'
                            })
                            that.$refs.form1.resetFields();
                            this.show1 = false
                            this.getCompanyUserAuthStatus()
                        })
                    }
                })
            },
            submit2() {
                console.log(this.form2);
                this.form2.provinceName = this.form2.region[0]
                this.form2.cityName = this.form2.region[1]
                this.form2.areaName = this.form2.region[2]
                let that = this
                that.$refs.form2.validate(valid => {
                    if (valid) {
                        that.$post('/api/company/company/companyAuth', { ...that.form2 }).then(res => {
                            that.$message({
                                message: '企业认证信息提交成功，请耐心等待审核',
                                type: 'success'
                            })
                            that.$refs.form2.resetFields();
                            this.show2 = false
                            this.getCompanyUserAuthStatus()
                        })
                    }
                })
            },
            async changeRegion(value) {
                console.log(value);
                this.form.provinceName = value[0]
                this.form.cityName = value[1]
                this.form.areaName = value[2]
                let addressStr = value.join('')
                let res = await this.$jsonp(
                    `https://apis.map.qq.com/ws/geocoder/v1`,
                    {
                        address: addressStr,
                        key: "RGEBZ-ARFKN-7NRF5-SNH73-OUVK3-KEBE7", // 你的key
                        type: 1,
                        output: "jsonp",
                    }
                );
                if (res.status === 0) {
                    this.coord = res.result.location.lat + ',' + res.result.location.lng
                }
            },

            async changeRegion2(value) {
                console.log(value);
                this.form2.provinceName = this.form2.region[0]
                this.form2.cityName = this.form2.region[1]
                this.form2.areaName = this.form2.region[2]
                let addressStr = value.join('')
                let res = await this.$jsonp(
                    `https://apis.map.qq.com/ws/geocoder/v1`,
                    {
                        address: addressStr,
                        key: "OO5BZ-Z7V6L-XFDP4-MPR6O-OD2XO-QPFVO", // 你的key
                        type: 1,
                        output: "jsonp",
                    }
                );
                if (res.status === 0) {
                    this.coord = res.result.location.lat + ',' + res.result.location.lng
                }
            },

            selectRegionTreeList() {
                this.$get('/api/common/selectRegionTreeList', {}).then(res => {
                    this.regionTreeList = res.data
                })
            },
            addPost() {
// 重置表单，这会设置 isUrgent: 0
              this.resetForm();

              this.getPositionWorkTypeList()
                this.selectRegionTreeList()
                this.selectTagList()
                this.getDictParamList()

                    console.log(this.authType,'authType');
                    
                
                if (this.authType == '2') {
                    this.addOrEdit = 'add'
                    this.submitType = 0
                    this.dialogFormVisible = true

                    setTimeout(() => {
                        this.$refs.form.resetFields()
                    }, 100);
                } else {
                    if (this.authType == '0') {
                        if (this.authObj.personExamineStatus == '0') {
                            this.show1 = true
                        } else if (this.authObj.personExamineStatus == '1') {
                            this.$message({
                                message: '实名信息正在审核中，请耐心等待',
                                type: 'warning'
                            })
                        } else if (this.authObj.personExamineStatus == '3') {
                            this.$message({
                                message: this.authObj.personExamineRefuseReason,
                                type: 'warning'
                            })
                            this.show1 = true
                        }
                    } else if (this.authType == '1') {
                        if (this.authObj.companyExamineStatus == null) {
                            this.show2 = true
                        } else if (this.authObj.companyExamineStatus == '0') {
                            this.$message({
                                message: '提交信息正在审核中，请耐心等待',
                                type: 'warning'
                            })
                        } else if (this.authObj.companyExamineStatus == '2') {
                            this.$message({
                                message: this.authObj.companyExamineRefuseReason,
                                type: 'warning'
                            })
                            this.show2 = true
                        }
                    }
                }
            },
            setAddress() {
                if (this.coord) {
                    this.show = true
                } else {
                    this.$message({
                        message: '请先选择工作地点',
                        type: 'warning'
                    })
                }
            },
            submit() {
                let that = this
                that.$refs.form.validate((valid) => {
                    console.log(that.form);
                    if (valid) {
                        var contactPhone = that.form.contactPhone;
                        var telephone = that.form.telephone;
                        debugger;
                        if (!contactPhone && !telephone) {
                            // 如果两个字段都为空
                            that.$message({
                                message: '联系方式和固定电话不能都为空，请至少填写一个。',
                                type: 'warning'
                            });
                            return false;
                        }
                        that.form.positionTag = that.form.positionTag.join(',')
                        that.form.workPeriod = that.form.workPeriod.join(',')
                        that.form.positionTypeId = that.form.positionType[0]
                        that.form.positionWorkTypeId = that.form.positionWorkTypeId.join(',')
                        that.form.positionTypeIdSecondary = that.form.positionType[1]
                        that.form.provinceName = that.form.region[0]
                        that.form.cityName = that.form.region[1]
                        that.form.areaName = that.form.region[2]
                        if (that.form.salaryUnit == '面议') {
                            that.form.salaryBegin = ''
                            that.form.salaryEnd = ''
                        }
                        if (that.form.positionId && that.submitType == 1) {
                            that.$post('/api/company/position/positionEdit', {
                                ...that.form
                            }).then(res => {
                                if (res.code == 200) {
                                    that.$message({
                                        message: '职位修改成功',
                                        type: 'success'
                                    })
                                    that.dialogFormVisible = false
                                    that.getCompanyPositionList()
                                }
                            })
                        } else if (that.submitType == 0 || that.submitType == 2) {
                            if (that.form.salaryUnit == '面议') {
                                that.form.salaryBegin = ''
                                that.form.salaryEnd = ''
                            }
                            that.$post('/api/company/position/positionRelease', {
                                ...that.form
                            }).then(res => {
                                if (res.code == 200) {
                                    that.$message({
                                        message: '职位添加成功',
                                        type: 'success'
                                    })
                                    that.dialogFormVisible = false
                                    that.getCompanyPositionList()
                                }
                            })
                        }
                    }
                })
            },
            workPeriodChange(value) {
                let str = value[value.length - 1]
                if (str == '早班' || str == '中班' || str == '晚班') {
                    if (value.indexOf('不限') != -1) {
                        value.splice(value.indexOf('不限'), 1)
                    }
                    if (value.indexOf('自定义') != -1) {
                        value.splice(value.indexOf('自定义'), 1)
                    }
                    this.form.workPeriod = value
                }

                if (str == '不限') {
                    this.form.workPeriod = ['不限']
                    return
                }
                if (str == '自定义') {
                    this.form.workPeriod = ['自定义']
                    return
                }
            },
            selectTagList() {
                this.$get("/api/common/selectTagList", {
                    tagType: 0,
                }).then((res) => {
                    this.tagList = res.data
                });
            },
            getDictParamList() {
                /*this.$get("/api/common/selectRuleByType", {
                    ruleType: 'company_informed_agreement',
                }).then((res) => {
                    this.company_informed_agreement = res.data
                });*/
                this.$get("/api/common/getDictParamList", {
                    paramType: 'settlement_method',
                }).then((res) => {
                    this.settlement_method = res.data
                });
                // this.$get("/api/common/getDictParamList", {
                //     paramType: 'week_work_day',
                // }).then((res) => {
                //     this.week_work_day = res.data
                // });
                this.$get("/api/common/getDictParamList", {
                    paramType: 'work_time',
                }).then((res) => {
                    this.work_time = res.data
                });
                this.$get("/api/company/position/getCommunityTypeListAll", {
                    communityTypeName: 'communityTypeList',
                }).then((res) => {
                    this.communityTypeList = res.data
                });
                // this.$get("/api/common/getDictParamList", {
                //     paramType: 'work_period',
                // }).then((res) => {
                //     this.work_period = res.data
                // });
                this.$get("/api/common/getDictParamList", {
                    paramType: 'salary_range',
                }).then((res) => {
                    this.salary_range = res.data
                });
            },
            closeDialog() {
                this.coord = ''
                this.$refs.form.resetFields()
            },

            edit(id, type) {

                this.dialogFormVisible = true
                this.getPositionWorkTypeList()
                this.selectRegionTreeList()
                this.selectTagList()
                this.getDictParamList()

                // this.resetForm()
                setTimeout(() => {
                    this.$refs.form.resetFields()
                }, 50);
                this.addOrEdit = type == 1 ? 'edit' : type == 2 ? 'again' : type == 3 ? 'check' : ''
                this.$get("/api/company/position/getCompanyPositionInfo", {
                    positionId: id,
                }).then((res) => {
                    // this.form = JSON.parse(JSON.stringify(res.data))

                    setTimeout(() => {
                        for (let i in res.data) {
                            this.form[i] = res.data[i] !== null ? res.data[i] : ''
                        }
                      // 特殊处理 isUrgent
                      this.form.isUrgent = res.data.isUrgent !== undefined ? res.data.isUrgent : 0;
                        this.form.positionDescribe = res.data.positionDescribe || ''
                        this.form.personnelRequire = res.data.personnelRequire || ''
                        this.form.welfareCommission = res.data.welfareCommission || ''
                      this.form.isUrgent = res.data.isUrgent !== undefined ? res.data.isUrgent : 0
                        this.form.positionType = [res.data.positionTypeId, res.data.positionTypeIdSecondary]
                        this.form.workPeriod = res.data.workPeriod ? res.data.workPeriod.split(',') : []
                        this.form.positionTag = res.data.positionTag ? res.data.positionTag.split(',') : []
                        this.form.positionWorkTypeId = res.data.positionWorkTypeId ? res.data.positionWorkTypeId.split(',') : []
                        this.submitType = type
                        this.form.region = []
                      this.form.isUrgent = res.data.isUrgent || 0; // 确保回显时包含 isUrgent
                        this.form.region[0] = res.data.provinceName ? res.data.provinceName.replace('市', '') : ''
                        this.form.region[1] = res.data.cityName
                        this.form.region[2] = res.data.areaName
                        this.coord = res.data.latitude + ',' + res.data.longitude
                        this.salaryUnit(res.data.salaryUnit)
                    }, 200)
                });
            },
            editStatus(id, status) {
                this.$post("/api/company/position/positionStatusEdit", {
                    positionId: id,
                    status
                }).then((res) => {
                    this.$message({
                        message: '状态修改成功',
                        type: 'success'
                    });
                    this.getCompanyPositionList()
                });
            },
            delPosition(id) {
                this.$post("/api/company/position/positionDelete", {
                    positionId: id
                }).then((res) => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getCompanyPositionList()
                });
            },
            showList(id) {
                let el = document.getElementsByClassName(`class${id}`)[0]
                if (el.style.display == 'none') {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                }
                if (this.chooseId != '' && this.chooseId != id) {
                    let el = document.getElementsByClassName(`class${this.chooseId}`)[0]
                    if (el) {
                        el.style.display = 'none';
                    }
                }
                this.chooseId = id
            },
            handleCurrentChange(value) {
                this.pageNum = value
                this.getCompanyPositionList()
            },
            handleChange(value) {
                // let nodesInfo = this.$refs['aaa'].getCheckedNodes()
                // console.log('nodesInfo>>>>>',nodesInfo)

                console.log('nodesInfo>>>>>', value)
                this.positionTypeIdSecondary = value[1]
                this.getCompanyPositionList()
            },
            loadCascaderOptions(node, resolve) {
                console.log(node)
                let id = node.value
                let level = node.level
                this.$get("/api/company/position/getPositionListByPid", {
                    pid: id,
                }).then(res => {
                    const nodes = Array.from(res.data, item => ({
                        //于stream流差不多，将后台返回的数据进行处理
                        value: item.positionTypeId, //选中项绑定值
                        label: item.typeName,//标签上显示文字
                        leaf: level == 1,//是否有子选项
                    }))
                    //将nodes返回
                    resolve(nodes);
                });
            },
            switchStatus(item, index) {
                this.active = index
                if (item.examineStatus) {
                    this.examineStatus = item.examineStatus
                } else {
                    this.examineStatus = ''
                }
                if (item.status) {
                    this.status = item.status
                } else {
                    this.status = ''
                }
                this.getCompanyPositionList()
            },
            getQrcode(id) {
                if (!this.qrCodeGet) {
                    this.qrcodePositionId = id
                    this.qrCodeGet = true
                    this.$get("/api/company/position/getPositionQrCodeForPC", {
                        positionId: id,
                    }).then((res) => {
                        this.qrcode = res.data.qrCode;
                        this.showShare = true;
                        this.qrCodeGet = false
                        return
                        setTimeout(() => {
                            // this.star(id);
                            this.showShare = true;
                        }, 500);
                    });
                } else {
                    this.$message({
                        message: '请勿重复点击',
                        type: 'warning'
                    });
                }
            },
            star(id) {
                const that = this;
                setTimeout(() => {
                    const canvas = document.getElementsByClassName(`id${id}`)[0];
                    // const canvas = this.$refs.canvas
                    // console.log(canvas.width, canvas.height)
                    const ctx = canvas.getContext("2d");
                    const width = canvas.width;
                    const height = canvas.height;
                    ctx.clearRect(0, 0, width, height);
                    const bg = new Image();
                    bg.src = "https://image.xnszz.com/e9214bc3c5bf87a99965509c1022ad49.png";
                    const qrcode = new Image();
                    qrcode.src = that.qrcode;
                    bg.onload = drawImage;
                    qrcode.onload = drawImage;
                    function drawImage() {
                        if (bg.complete && qrcode.complete) {
                            ctx.drawImage(bg, 0, 0, width, height);
                            ctx.drawImage(qrcode, (width - 100) / 2, height / 2 - 90, 80, 80); //绘制图片
                            //设置填充文字样式
                            ctx.font = "26px PingFang SC";
                            ctx.fillStyle = "#FFFFFF";
                            //设置文字及其位置
                            ctx.fillText("工程建造师", 50, 60);
                            ctx.font = "18px PingFang SC";
                            ctx.fillText("薪资：10-20K", 50, 100);
                            ctx.fillText("识别二维码获得更多岗位信息", 50, 435);
                        }
                    }
                }, 500);
            },
            closeShare() {
                this.showShare = false;
            },
            getPositionListByPid1() {
                this.$get('/api/company/position/getPositionTypeListAll', {}).then(res => {
                    this.positionTypeList = res.data
                })
            },
            getCompanyUserIdMethod() {
                this.$get('/api/company/position/getCompanyUserId', {}).then(res => {
                    this.companyUserId = res.data.companyUserId;
                    console.log(this.companyUserId)
                    //0f79248375ff42c6a54926a57e8c61c2
                })
            },
            getCompanyPositionList() {
                this.$get("/api/company/position/getCompanyPositionListForPC", {
                    examineStatus: this.examineStatus,
                    status: this.status,
                    positionTypeIdSecondary: this.positionTypeIdSecondary,
                    keyWords: this.keyWords,
                    orderType: this.orderType,
                    pageNum: this.pageNum,
                    pageSize: 10
                }).then((res) => {
                    this.positionList = res.data.list;
                    this.total = res.data.total;
                });
            },
        },
    };
</script>
<style scoped>
    .main {
        padding: 20px;
        /* padding: 10px; */
    }

    .mapDialog {
        margin: auto;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .title1 {
        width: 122px;
        height: 42px;
        background: #0051aa;
        border-radius: 2px;
        font-weight: normal;
        font-size: 16px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
    }

    .title2 {
        display: flex;
    }

    .search {
        display: flex;
        margin-right: 20px;
    }

    .filter {
        display: flex;
    }

    .filter>div {
        padding: 8px 20px;
        height: 22px;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
    }

    .common {
        color: #555555;
    }

    .active {
        background-color: #0051aa;
        color: #ffffff;
    }

    .postManagement {
        margin-bottom: 70px;
        margin-top: 20px;
    }

    .postManagementList1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 14px;
        padding: 33px 40px;
        height: 30px;
        background: linear-gradient(180deg, #e6eff7 0%, #ffffff 100%);
        border-radius: 6px;
    }

    .postManagementList1>div {
        flex: 1;
    }

    .postManagementList1>.item3Two {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #555555;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .postManagementList1>.item3Two>div:nth-of-type(1) {
        margin-right: 10px;
    }

    .postManagementList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 14px;
        padding: 33px 40px;
        height: 80px;
        background: linear-gradient(180deg, #e6eff7 0%, #ffffff 100%);
        border-radius: 6px;
    }

    .postManagementList>div {
        flex: 1;
    }

    .item1>div:nth-of-type(1) {
        /* width: 72px; */
        height: 25px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #555555;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .item1>div:nth-of-type(2) {
        margin-top: 20px;
        height: 22px;
        font-family: PingFangSC-Regular, PingFangSC-Regular;
        font-weight: normal;
        font-size: 16px;
        color: #555555;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .item1>div:nth-of-type(2)>span:nth-of-type(1) {
        margin-left: 0;
    }

    .item1>div:nth-of-type(2)>span {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
    }

    .item2 {
        display: flex;
        /* margin-left: 240px; */
    }

    .item2>div {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 30px;
        font-family: PingFangSC-Regular, PingFangSC-Regular;
        font-weight: normal;
        font-size: 16px;
        color: #555555;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }

    .item2>div>div:nth-of-type(2) {
        margin-top: 20px;
    }

    .item3 {
        /* display: flex; */
        margin-left: 50px;
        font-weight: normal;
        font-size: 14px;
        color: #555555;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        position: relative;
    }

    .item3>div:nth-of-type(1) {
        margin-bottom: 10px;
    }

    .item4 {
        display: flex;
        justify-content: flex-end;
        /* justify-content: space-around; */
    }

    .item4>div {
        line-height: 22px;
        cursor: pointer;
        font-weight: normal;
        font-size: 14px;
        color: #0051AA;
        text-align: center;
        margin-right: 10px;
    }

    .item4>div:nth-last-child(1) {
        margin-right: 0px;
    }

    .hiddenList {
        height: auto !important;
        position: absolute;
        left: 180px;
        top: 30px;
        background-color: #FFFFFF;
    }

    .hiddenList>div {
        height: 20px;
        background-color: #FFFFFF;
        padding: 4px;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .hiddenList>div:hover {
        background-color: #0051AA;
        color: #FFFFFF;
    }

    .form {
        /* width: 800px; */
        text-decoration: none;
    }

    ::v-deep .el-input__inner {
        background-color: #f2f3f5;
    }

    ::v-deep .el-textarea__inner {
        background-color: #f2f3f5;
    }

    .sha_image {
        /* width: 400px; */
        /* height: 700px; */
        /* background-image: url('https://image.xnszz.com/e9214bc3c5bf87a99965509c1022ad49.png'); */
        /* background-repeat: no-repeat;
        background-size: 100% 100%; */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sha_image>img {
        width: 100%;
        height: 100%;
    }

    /* 画布 */
    canvas {
        width: 240px;
        height: 300px;
        position: absolute;
    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>

<style>
    .el-table__header,
    .el-table__body {
        width: 100% !important;
    }

    .qrcodeDialog .el-dialog,
    .el-dialog__wrapper .el-dialog {
        margin-top: 5vh !important;
    }

    .ellipsis {
        overflow: hidden;
        /*内容超出后隐藏*/
        text-overflow: ellipsis;
        /*超出内容显示为省略号*/
        white-space: nowrap;
        /*文本不进行换行*/
    }
</style>